// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Flex, Pane, Text } from '@leverege/ui-elements'

import S from './PlyLayerShopFloor.css'

export default function PlyLayerNoData( props ) {
  const { shellName, isNextSA } = props

  return (
    <Flex variant='colXL' align='center' justify='center' className={S.container}>
      <Pane>
        <Pane variant='mobileCardCustomHeader'>
          <Text variant='mobilePaceCardBigHeader'>
            {shellName}
            {isNextSA && <Text as="span" variant='mobileSmallLabel'>(Next SA)</Text>}
          </Text>
        </Pane>
      </Pane>
      <Pane>
        <Text 
          variant='mobilePaceCardHeader'
          align='center'
          justify='center'>
          Layup Not In Progress
        </Text>
        <Text
          align='center'
          justify='center'>
          The page will refresh automatically when layup begins.
        </Text>
      </Pane>
    </Flex>
  )
}
